var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-switch',{attrs:{"value":_vm.value,"active-color":"#f56c6c"},on:{"change":_vm.toggle}})
}
var staticRenderFns = []

export { render, staticRenderFns }